import { render, staticRenderFns } from "./GateDescription.vue?vue&type=template&id=ac52fa6c&scoped=true"
import script from "./GateDescription.vue?vue&type=script&lang=ts"
export * from "./GateDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac52fa6c",
  null
  
)

export default component.exports